export const getSlug = (host?: string) => {
  const { hostname } = new URL(
    `http://${
      host ?? (typeof window !== 'undefined' ? window.location.host : 'storex')
    }`
  );
  return hostname === 'localhost' ? 'storex' : hostname.split('.')[0];
};
